import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import Paper from 'material-ui/Paper';
import FloatingActionButton from 'material-ui/FloatingActionButton'

import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import Delete from 'material-ui/svg-icons/action/delete';
import Edit from 'material-ui/svg-icons/editor/mode-edit';
import Copy from 'material-ui/svg-icons/content/content-copy';
import ContentAdd from 'material-ui/svg-icons/content/add';

import BridgeAppBar from './MainComponents/BridgeAppBar';
import clientsStore from '../stores/clientsStore';

// import _ from 'lodash';

// TODO: Agregar clases de visualizacion para hover.
const Command = ({command, onDelete, onEdit, onCopyAndCreate}) => (
    <Paper className="commandItem">
        <div style={{paddingLeft: "28px", marginBottom: "8px"}}>Codigo de comando: { command.StoredCommandID } </div>
        <div><span><ChevronRight color={"#757575"} /></span> <span style={{
            verticalAlign: "top", fontSize: "18px", fontWeight: "300"
        }}>{ command.target } { command.arguments }</span> </div>
        <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Working directory:</span> { command.workingDirectory } </div>

        <div style={{textAlign: "right"}} className="commandButtons">            
            <IconButton 
                tooltip="Copiar y pegar"
                onTouchTap={() => { onCopyAndCreate(command) } }>
                <Copy color={"#2196F3"} />
            </IconButton>
            <IconButton 
                tooltip="Editar"
                onTouchTap={() => { onEdit(command) } }>
                <Edit color={"#2196F3"} />
            </IconButton>
            <IconButton 
                tooltip="Eliminar" 
                onTouchTap={() => { onDelete(command) } }>
                <Delete color={"#F44336"} />
            </IconButton>
        </div>
    </Paper>
);

const CommandList = ({commands, onDelete, onEdit, onCopyAndCreate}) => (
    <div>
        {
            commands.map((item, index) => (
                <Command key={index} 
                    command={item} 
                    onDelete={onDelete} 
                    onEdit={onEdit} 
                    onCopyAndCreate={onCopyAndCreate} 
                />
            ))
        }
    </div>
);

const CommandFormButtons = ({onClose, onSubmit}) => (
    <div>
        <FlatButton
            label="Cancelar"
            primary={true}
            onTouchTap={onClose}
        />
        <FlatButton
            label="Guardar"
            primary={true}
            onTouchTap={onSubmit}
        />
    </div>
)

class CommandDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open                    : false,
            errorCommand            : "",
            defaultTarget           : "",
            defaultArguments        : "",
            defaultWorkingDirectory : "",
            defaultStoredCommandID  : "",
            isUpdate                : false
        }
    }
    __openAndSetFields(data) {
        this.setState({
            defaultStoredCommandID  : data.storedCommandID,
            defaultTarget           : data.target,
            defaultArguments        : data.arguments,
            defaultWorkingDirectory : data.workingDirectory,
            isUpdate                : data.isUpdate || false,
            open                    : true
        });
    }
    _onClose() {
        this.setState({open: false});
    }
    _onSubmit() {
        let txtComando          = document.getElementById("txtComando").value;
        let txtArgumentos       = document.getElementById("txtArgumentos").value;
        let txtWorkingDirectory = document.getElementById("txtWorkingDirectory").value;

        if(txtComando.trim() === "") {
            this.setState({errorCommand: "El comando no puede estar vacio"});
        } else {
            // submit
            if(this.state.isUpdate) {
                //TODO: Save stored command
                this.props.editStoredCommand({
                    StoredCommandID     : this.state.defaultStoredCommandID,
                    target              : txtComando,
                    arguments           : txtArgumentos,
                    workingDirectory    : txtWorkingDirectory
                }, () => {
                    // onSuccess
                    this._clearAndClose();
                });
            } else {
                this.props.addStoredCommand({
                    target              : txtComando,
                    arguments           : txtArgumentos,
                    workingDirectory    : txtWorkingDirectory
                }, () => {
                    // onSuccess
                    this._clearAndClose();
                });
            }
        }
    }
    _clearAndClose() {
        this.setState({
            errorCommand            : "",
            defaultTarget           : "",
            defaultArguments        : "",
            defaultWorkingDirectory : "",
            defaultStoredCommandID  : "",
            open                    : false,
            isUpdate                : false
        });
    }
    _clearAndOpen() {
        this.setState({
            errorCommand            : "",
            defaultTarget           : "",
            defaultArguments        : "",
            defaultWorkingDirectory : "",
            defaultStoredCommandID  : "",
            open                    : true,
            isUpdate                : false
        })
    }
    render() {
        return (
            <div>
                <FloatingActionButton 
                    style={{position: "fixed", right: "32px", bottom: "32px"}} 
                    onTouchTap={() => { this._clearAndOpen() } } 
                >
                    <ContentAdd />
                </FloatingActionButton>
                <Dialog
                    title="Datos de comando"
                    actions={
                        <CommandFormButtons 
                            onClose={this._onClose.bind(this)} 
                            onSubmit={() => {
                                this._onSubmit();
                            }}
                        />
                    }
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this._onClose.bind(this)}
                    autoScrollBodyContent={true}
                >
                    <TextField
                        hintText='Program.exe || "D:\Dir with spaces\program.exe" '
                        floatingLabelText="Comando"
                        fullWidth={true}
                        id="txtComando"
                        errorText={this.state.errorCommand}
                        defaultValue={this.state.defaultTarget}
                    />
                    <TextField
                        hintText='"arg1 with spaces" arg2 arg3'
                        floatingLabelText="Argumentos"
                        fullWidth={true}
                        id="txtArgumentos"
                        defaultValue={this.state.defaultArguments}
                    />
                    <TextField
                        hintText='D:\dir || "D:\dir with spaces"' 
                        floatingLabelText="Working Directory"
                        fullWidth={true}
                        id="txtWorkingDirectory"
                        defaultValue={this.state.defaultWorkingDirectory}
                    />
                </Dialog>
            </div>    
        )
    }
}
// eslint-disable-next-line
class DeleteCommandDialog extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }
    render() {
        const actions = [
            <FlatButton
                label="Cancelar"
                primary={true}
                onTouchTap={this.handleClose}
            />,
            <FlatButton
                label="Borrar"
                primary={true}
                keyboardFocused={true}
                onTouchTap={this.handleClose}
            />
        ];
        return (
            <Dialog
                title="Borrar comando"
                actions={actions}
                modal={false}
                open={this.state.open}
                onRequestClose={this.handleClose}
            >
                Seguro que desea borrar el comando
            </Dialog>
        )
    }
}
class Commands extends Component {
    constructor(props) {
        super(props);
        this.state = {
            storedCommands: [],
            clientName: ""
        }
    }
    componentDidMount() {
        clientsStore.getClients({
            id: this.props.match.params.id,
            onSuccess: (response) => {
                ////console.warn("COMPONENT DID MOUNT, COMMANDS: " + JSON.stringify(response));
                this.setState({
                    storedCommands: response.storedCommands,
                    clientName: response.clientName 
                });
            }
        });
        ////console.warn("COMPONENT DID MOUNT" + this.state.storedCommands);
    }

    _onDelete(command) {
        console.log("Delete", command);
        clientsStore.deleteStoredCommand({
            command: command,
            onSuccess: (storedCommands) => {
                this.setState({storedCommands: storedCommands});
            },
            onError: () => {

            }
        })
    }
    _onEdit(data) {
        console.log("Edit", data);
        this.cmdDialog.__openAndSetFields({
            storedCommandID     : data.storedCommandID,
            target              : data.target,
            arguments           : data.arguments,
            workingDirectory    : data.workingDirectory,
            isUpdate            : true
        });
    }
    
    _onCopyAndCreate(data) {
        console.log("Copy and create", data);

        this.cmdDialog.__openAndSetFields({
            target           : data.target,
            arguments        : data.arguments,
            workingDirectory : data.workingDirectory,
        });
    }

    _updateCommand(data, onSuccess, onError) {
        
        clientsStore.editStoredCommand({
            command: {
                clientID            : this.props.match.params.id,
                StoredCommandID     : data.StoredCommandID,
                target              : data.target,
                arguments           : data.arguments,
                workingDirectory    : data.workingDirectory
            },
            onSuccess: (storedCommands) => {
                // this.setState({storedCommands: storedCommands});
                this._refreshCommands(storedCommands);
                if(onSuccess) onSuccess();
            },
            onError: () => {
                if(onError) onError();
            }
        });
    }
    
    _createCommand(data, onSuccess, onError) {
        clientsStore.createStoredCommand({
            newCommand: {
                clientID        : this.props.match.params.id,
                target          : data.target,
                arguments       : data.arguments,
                workingDirectory: data.workingDirectory
            },
            onSuccess: (storedCommands) => {
                // this.setState({storedCommands: storedCommands});
                this._refreshCommands(storedCommands);
                if(onSuccess) onSuccess();
            },
            onError: () => {
                if(onError) onError();
            }
        });
    }
    _refreshCommands(newStoredCommands) {
        this.setState({storedCommands: newStoredCommands});
    }
    render() {
        return (
            <div>
                <BridgeAppBar 
                    toCommands={"/commands/" + this.props.match.params.id} 
                    toStoredCommands={"/storedcommands/" + this.props.match.params.id} 
                    toClient={{ url: "/clientdetails/" + this.props.match.params.id, display: this.state.clientName }} 
                    toLogs={"/logs/" + this.props.match.params.id} 
                />
                <CommandList commands={this.state.storedCommands} 
                    onDelete = {this._onDelete.bind(this)}
                    onEdit={(command) => {
                        this._onEdit({
                            storedCommandID : command.StoredCommandID,
                            target          : command.target,
                            arguments       : command.arguments,
                            workingDirectory: command.workingDirectory
                        });
                    }}
                    onCopyAndCreate={(command) => {
                        this._onCopyAndCreate({
                            target          : command.target,
                            arguments       : command.arguments,
                            workingDirectory: command.workingDirectory
                        });
                    }}
                />
                
                <CommandDialog 
                    clientID={this.props.match.params.id} 
                    editStoredCommand={(data, onSuccess, onError) => {
                        this._updateCommand(data, onSuccess, onError);
                    }}
                    addStoredCommand={(data, onSuccess, onError) => {
                        this._createCommand(data, onSuccess, onError)
                    }}
                    ref={(cmdDialog) => { this.cmdDialog = cmdDialog; }}
                />

            </div>
        );
    }
}

export default Commands;


// WEBPACK FOOTER //
// ./src/components/StoredCommands.js